export default __webpack_public_path__ + "static/tidslinje-6d6a79040784f99f40867b4c3c5ea47e.jpg";